import React from 'react';
import { MapPin } from 'lucide-react';
import Heading from '../ui/Heading';

const NearbyAmenities = ({ amenities }) => {
  // Group amenities by category
  const categories = {
      'Business & Commerce': ['IT Hubs', 'Business Parks', 'Office Complexes', 'Corporate Centers'],
      'Healthcare': ['Hospitals', 'Clinics', 'Pharmacies'],
      'Education': ['Schools', 'Universities', 'Libraries'],
      'Shopping': ['Malls', 'Supermarkets', 'Retail Stores'],
      'Transportation': ['Bus Stops', 'Metro Stations', 'Airports'],
    'Recreation': ['Recreation', 'Gyms', 'Sports Facilities'],
    'Dining': ['Restaurants', 'Cafes', 'Food Courts']
  };

  // Filter amenities by their category
  const categorizedAmenities = Object.keys(categories).map(category => {
    const items = amenities.filter(amenity => 
      categories[category].some(keyword => 
        amenity.toLowerCase().includes(keyword.toLowerCase())
      )
    );
    
    return { category, items };
  }).filter(group => group.items.length > 0);

  // Uncategorized amenities
  const otherAmenities = amenities.filter(amenity => 
    !Object.values(categories).flat().some(keyword => 
      amenity.toLowerCase().includes(keyword.toLowerCase())
    )
  );

  if (otherAmenities.length > 0) {
    categorizedAmenities.push({ category: 'Other', items: otherAmenities });
  }

  return (
    <div className="mt-14">
      <Heading level={4} className='text-center mb-6'>Nearby Amenities</Heading>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        {categorizedAmenities.map((group, index) => (
          <div key={index} className=" p-4 rounded-lg transition-shadow duration-300">
            <h5 className=" uppercase tracking-wider text-gray-500 mb-3">{group.category}</h5>
            <ul className="space-y-2">
              {group.items.map((amenity, i) => (
                <li key={i} className="flex items-center text-gray-700">
                  <MapPin size={16} className="mr-2 text-yellow-500 flex-shrink-0" />
                  <span className="">{amenity}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NearbyAmenities;